import styled from 'styled-components';

interface formContentProps {
  showBorder?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const FormContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > * {
    width: 100%;
  }
`;

export const BorderContent = styled.div<formContentProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
